import {IToJson} from '@toolify/client/src/types/IToJson'
import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {
  IEntityInterfacesByEntityType,
} from '@toolify/server/src/services/EntityService/types/IEntityInterfacesByEntityType'
import {mapUserResponseInstance} from '@toolify/client/src/modules/api/singletons/mapUserResponseInstance'
import {mapAppEntityResponsePayload} from '@toolify/client/src/modules/api/singletons/mapAppEntityResponsePayload'

export function mapResponseEntity(
  authorEntity: IToJson<IResponseEntity>,
): IResponseEntity {
  let payload: IEntityInterfacesByEntityType[EntityType]['responseInstance']
  if(authorEntity.entityType === EntityType.User) {
    payload = mapUserResponseInstance(authorEntity.payload as IToJson<IEntityInterfacesByEntityType[EntityType.User]['responseInstance']>)
  } else if(authorEntity.entityType === EntityType.App) {
    payload = mapAppEntityResponsePayload(authorEntity.payload as IToJson<IEntityInterfacesByEntityType[EntityType.App]['responseInstance']>)
  } else {
    payload = authorEntity.payload as IEntityInterfacesByEntityType[EntityType]['responseInstance']
  }

  return {
    entityType: authorEntity.entityType,
    entityId: authorEntity.entityId,
    payload,
  }
}
